import React from "react";
import { NavLink } from "react-router-dom";
import { Home, ShoppingBag, LayoutDashboard, TrendingUp, HelpCircle } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: Home, id: "home" },
  { to: "/sell", label: "Sell", icon: ShoppingBag, id: "sell" },
  { to: "/rates", label: "Rates", icon: TrendingUp, id: "rates" },
  { to: "/dashboard", label: "Account", icon: LayoutDashboard, id: "account" },
  { to: "/faq", label: "Help", icon: HelpCircle, id: "help" },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-lg border-t border-slate-200 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, id }) => (
          <NavLink
            key={id}
            to={to}
            data-testid={`bottom-nav-${id}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center py-2.5 gap-1 text-[11px] font-medium ${
                isActive ? "text-[#0B3C5D]" : "text-slate-500"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
